import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Spinner from '../Spinner';
import { efesOrange } from '../../../theme';

import styles from './Loader.module.scss';

const Loader = ({ text, color }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.background}>
      <div className={styles.center}><Spinner color={color} /></div>
      <div className={styles.content}>
        <div className={styles.text} style={{ color }}>{t(text)}</div>
      </div>
    </div>
  );
};

Loader.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
};

Loader.defaultProps = {
  text: 'loading',
  color: efesOrange,
};

export default Loader;
